import type { SliceComponentProps } from "@prismicio/react";
import type { KlaviyoEmbedFormSlice } from "prismicio-types";
import { useEffect } from "react";
import KlaviyoEmbedFormDefault from "./variations/default";
import KlaviyoEmbedFormTwoColumn from "./variations/twoColumn";

const DEFAULT_KLAVIYO_COMPANY_ID = "RLAjHJ";

const KlaviyoEmbedForm = ({
  slice,
}: SliceComponentProps<KlaviyoEmbedFormSlice>) => {
  const match = slice.primary.embed?.match(/klaviyo-form-([A-Za-z0-9]+)/);
  const formId = match?.[1];
  const companyId =
    slice.primary.company_id?.trim() || DEFAULT_KLAVIYO_COMPANY_ID;
  const klaviyoEmbedScript = `//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${companyId}`;

  // Klaviyo script inserted from GTM or ExternalScripts regarding 'enable_klaviyo' gate check
  // This is a fallback to ensure the load main account if the slice is used without Klaviyo script for any reason
  useEffect(() => {
    if (
      !formId ||
      document.querySelector(`script[src="${klaviyoEmbedScript}"]`)
    ) {
      return;
    }

    const script = document.createElement("script");
    script.src = klaviyoEmbedScript;
    script.type = "text/javascript";
    script.async = true;
    script.setAttribute("data-origin", "prismic-embed-slice");
    document.head.appendChild(script);
  }, [formId, klaviyoEmbedScript]);

  if (!formId) {
    return null;
  }

  switch (slice.variation) {
    case "twoColumn":
      return <KlaviyoEmbedFormTwoColumn slice={slice} formId={formId} />;
    default:
      return <KlaviyoEmbedFormDefault slice={slice} formId={formId} />;
  }
};

export default KlaviyoEmbedForm;
